module.exports = __webpack_public_path__ + "static/img/shui-5.5063148.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shuiBrand/shui-5.png
// module id = RB8Y
// module chunks = 0